var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", [
    _c("h2", { staticClass: "mb-6" }, [_vm._v(_vm._s(_vm.organization.name))]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-6" },
      [
        _c("label", { ref: "image", attrs: { for: "dropzone" } }, [
          _vm._v("\n      Profile Photo\n      "),
          _c("span", { staticClass: "mb-5 text-sm font-sans-book block" }, [
            _vm._v(
              "\n        Please upload a horizontal/landscape image (JPEG or PNG), ideally 400 pixels x 300 pixels. This should represent you or your organization. If you are an individual representing the entire organization, you may use a photo of your face. Be sure to click Update at the bottom of the page once you have uploaded your photo.\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _vm.organization && _vm.organization.profilePhoto
          ? _c("div", [
              _c("img", {
                staticClass: "h-48 mb-2",
                attrs: {
                  src: _vm.organization.profilePhoto,
                  alt: _vm.organization.name,
                },
              }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "vue-dropzone",
          {
            ref: "image",
            attrs: {
              id: "dropzone",
              options: _vm.dropzoneOptions,
              useCustomSlot: true,
            },
            on: {
              "vdropzone-success": _vm.uploaded,
              "vdropzone-error": _vm.updateImageErrorMessage,
              "vdropzone-removed-file": _vm.resetImage,
            },
          },
          [
            _c("div", { staticClass: "after-drop-message" }, [
              _c("p", [
                _vm._v(
                  "You may drag-and-drop an image here. File size must be less than 4 MB."
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _vm.imageError
          ? _c("span", { staticClass: "text-lg error text-error-red" }, [
              _vm._v("\n      " + _vm._s(_vm.imageError) + "\n    "),
            ])
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "mb-12" }, [
      _c("label", { ref: "story", attrs: { for: "story" } }, [
        _vm._v("\n      What’s your organization’s story? "),
        _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("span", { staticClass: "text-sm font-sans-book block" }, [
          _vm._v(
            "\n        900 characters maximum. This is your bio and description, which can include your mission statement, types of resources you provide, and/or what inspired you to do this work. Use I/we when you can; stories are better when they are in your personal voice!\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.story,
            expression: "form.story",
          },
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|max:900",
            expression: "'required|max:900'",
          },
        ],
        staticClass:
          "w-full mt-3 p-4 overflow-y-scroll border border-black h-48 bg-transparent",
        attrs: { id: "story", name: "story" },
        domProps: { value: _vm.form.story },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "story", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-sm font-sans-italic text-gray-dark mt-1" },
        [
          _vm._v(
            "\n      Character count: " + _vm._s(_vm.storyCount) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("story"),
              expression: "errors.has('story')",
            },
          ],
          staticClass: "error text-error-red text-lg",
        },
        [_vm._v("\n      " + _vm._s(_vm.errors.first("story")) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-12" }, [
      _c("label", { ref: "reimagine", attrs: { for: "reimagine" } }, [
        _vm._v(
          "\n      Finish the following: \"What I'm / What we're here to reimagine...\" "
        ),
        _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
        _vm._v(" "),
        _c("span", { staticClass: "text-sm font-sans-book block" }, [
          _vm._v(
            "\n        240 characters maximum. What is your inspiring vision, mantra, or change you wish to see in the world? Keep this short, sweet, and unique.\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.reimagine,
            expression: "form.reimagine",
          },
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|max:240",
            expression: "'required|max:240'",
          },
        ],
        staticClass:
          "w-full mt-3 p-4 overflow-y-scroll border border-black h-48 bg-transparent",
        attrs: { id: "reimagine", name: "reimagine" },
        domProps: { value: _vm.form.reimagine },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "reimagine", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "text-sm font-sans-italic text-gray-dark mt-1" },
        [
          _vm._v(
            "\n      Character count: " + _vm._s(_vm.reimagineCount) + "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.errors.has("reimagine"),
              expression: "errors.has('reimagine')",
            },
          ],
          staticClass: "error text-error-red text-lg",
        },
        [_vm._v("\n      " + _vm._s(_vm.errors.first("reimagine")) + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-12" }, [
      _c("label", { attrs: { for: "publicPhone" } }, [
        _vm._v("\n      Public Phone Number\n    "),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.publicPhone,
            expression: "form.publicPhone",
          },
        ],
        attrs: { id: "publicPhone", type: "text", name: "publicPhone" },
        domProps: { value: _vm.form.publicPhone },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "publicPhone", $event.target.value)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "mb-12" }, [
      _c("label", { attrs: { for: "publicEmail" } }, [
        _vm._v("\n      Public Email\n    "),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.form.publicEmail,
            expression: "form.publicEmail",
          },
        ],
        attrs: { id: "publicEmail", type: "text", name: "publicEmail" },
        domProps: { value: _vm.form.publicEmail },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.form, "publicEmail", $event.target.value)
          },
        },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-12" },
      [
        _c("label", { attrs: { for: "facebookUrl" } }, [
          _vm._v("\n      Facebook URL\n    "),
        ]),
        _vm._v(" "),
        _c("url-input", {
          attrs: { id: "facebookUrl" },
          model: {
            value: _vm.form.facebookUrl,
            callback: function ($$v) {
              _vm.$set(_vm.form, "facebookUrl", $$v)
            },
            expression: "form.facebookUrl",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-12" },
      [
        _c("label", { attrs: { for: "twitterUrl" } }, [
          _vm._v("\n      Twitter URL\n    "),
        ]),
        _vm._v(" "),
        _c("url-input", {
          attrs: { id: "twitterUrl" },
          model: {
            value: _vm.form.twitterUrl,
            callback: function ($$v) {
              _vm.$set(_vm.form, "twitterUrl", $$v)
            },
            expression: "form.twitterUrl",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-12" },
      [
        _c("label", { attrs: { for: "instagramUrl" } }, [
          _vm._v("\n      Instagram URL\n    "),
        ]),
        _vm._v(" "),
        _c("url-input", {
          attrs: { id: "instagramUrl" },
          model: {
            value: _vm.form.instagramUrl,
            callback: function ($$v) {
              _vm.$set(_vm.form, "instagramUrl", $$v)
            },
            expression: "form.instagramUrl",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-12" },
      [
        _c("label", { attrs: { for: "linkedinUrl" } }, [
          _vm._v("\n      LinkedIn URL\n    "),
        ]),
        _vm._v(" "),
        _c("url-input", {
          attrs: { id: "linkedinUrl" },
          model: {
            value: _vm.form.linkedinUrl,
            callback: function ($$v) {
              _vm.$set(_vm.form, "linkedinUrl", $$v)
            },
            expression: "form.linkedinUrl",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "w-full md:pl-10 md:w-3/4 md:pr-10" },
      [
        _vm._l(_vm.taxonomyGroups, function (group) {
          return _c("div", { key: group.id, staticClass: "mb-8" }, [
            _c("label", { ref: "taxonomy", refInFor: true }, [
              _vm._v("\n            " + _vm._s(group.title) + " "),
              _c("span", { staticClass: "text-red" }, [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "group__checkbox" }, [
              _c(
                "div",
                { staticClass: "flex flex-wrap select-box" },
                [
                  _vm._l(group.taxonomies, function (taxonomy) {
                    return [
                      _c(
                        "label",
                        {
                          key: taxonomy.id,
                          staticClass:
                            "w-full text-base font-normal md:w-1/2 md:pr-3",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.form.taxonomies,
                                expression: "form.taxonomies",
                              },
                            ],
                            attrs: { name: "taxonomy", type: "checkbox" },
                            domProps: {
                              value: taxonomy.id,
                              checked: Array.isArray(_vm.form.taxonomies)
                                ? _vm._i(_vm.form.taxonomies, taxonomy.id) > -1
                                : _vm.form.taxonomies,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.form.taxonomies,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = taxonomy.id,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.form,
                                        "taxonomies",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.form,
                                        "taxonomies",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.form, "taxonomies", $$c)
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "inline-block mr-2 check",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(taxonomy.title) +
                              "\n                    "
                          ),
                        ]
                      ),
                    ]
                  }),
                ],
                2
              ),
            ]),
          ])
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("taxonomy"),
                expression: "errors.has('taxonomy')",
              },
            ],
            staticClass: "text-lg error text-error-red",
          },
          [_vm._v(_vm._s(_vm.errors.first("taxonomy")))]
        ),
      ],
      2
    ),
    _vm._v(" "),
    _vm.user.isAdmin
      ? _c("div", { staticClass: "mb-12" }, [
          _c("div", { staticClass: "select-box" }, [
            _c(
              "label",
              {
                staticClass: "text-base font-normal",
                attrs: { for: "contractOverride" },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.contractOverride,
                      expression: "form.contractOverride",
                    },
                  ],
                  attrs: { id: "contractOverride", type: "checkbox" },
                  domProps: {
                    checked: Array.isArray(_vm.form.contractOverride)
                      ? _vm._i(_vm.form.contractOverride, null) > -1
                      : _vm.form.contractOverride,
                  },
                  on: {
                    change: function ($event) {
                      var $$a = _vm.form.contractOverride,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(
                              _vm.form,
                              "contractOverride",
                              $$a.concat([$$v])
                            )
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.form,
                              "contractOverride",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.form, "contractOverride", $$c)
                      }
                    },
                  },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "check inline-block mr-2" }),
                _vm._v(" Override Festival Contract\n      "),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "button",
        on: {
          click: function ($event) {
            $event.stopPropagation()
            $event.preventDefault()
            return _vm.update.apply(null, arguments)
          },
        },
      },
      [_vm._v("\n    Update\n  ")]
    ),
    _vm._v(" "),
    _vm.organization && _vm.organization.id && _vm.user && _vm.user.isAdmin
      ? _c(
          "div",
          { staticClass: "mb-3" },
          [
            _c("admin-queueton-status", {
              attrs: {
                "resource-id": _vm.organization.id,
                resource: "organization",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "mb-6" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }